<script lang="ts" setup>
import SortIcon from "~/assets/icons/arrows/arrowSearchTableDesktopSort.svg";
import useSearchStore from "~/shared/store/modules/search";

const searchStore = useSearchStore();
</script>

<template>
  <div class="search__table-header">
    <div class="search__table-cell">
      <button class="search__table-sort-btn" :class="[
        searchStore.analogsListSorting.sortByBrand !== null && 'active',
        searchStore.analogsListSorting.sortByBrand && 'rotate_arrow',
      ]" @click="searchStore.setAnalogsSorting('sortByBrand')">
        <span>Бренд</span>
        <span class="svg-fill-black">
          <SortIcon class="unfilled" />
        </span>
      </button>
      <button class="search__table-sort-btn" :class="[
        searchStore.analogsListSorting.sortByArticle !== null && 'active',
        searchStore.analogsListSorting.sortByArticle && 'rotate_arrow'
      ]" @click="searchStore.setAnalogsSorting('sortByArticle')">
        <span>Артикул</span>
        <span class="svg-fill-black">
          <SortIcon class="unfilled" />
        </span>
      </button>
    </div>
    <div class="search__table-cell">
      <button class="search__table-sort-btn" :class="[
        searchStore.analogsListSorting.sortByName !== null && 'active',
        searchStore.analogsListSorting.sortByName && 'rotate_arrow'
      ]" @click="searchStore.setAnalogsSorting('sortByName')">
        <span>Наименование</span>
        <span class="svg-fill-black">
          <SortIcon class="unfilled" />
        </span>
      </button>
    </div>
    <div class="search__table-cell">
      <div class="search__table-cell-sub"></div>
      <div class="search__table-cell-sub"></div>
      <div class="search__table-cell-sub">
        <button class="search__table-sort-btn" :class="[
          searchStore.warehousesListSorting.sortByCity !== null && 'active',
          searchStore.warehousesListSorting.sortByCity && 'rotate_arrow'
        ]" @click="searchStore.setWarehousesSorting('sortByCity')">
          <span>Город</span>
          <span class="svg-fill-black">
            <SortIcon class="unfilled" />
          </span>
        </button>
      </div>
      <div class="search__table-cell-sub">
        Склад
      </div>
      <div class="search__table-cell-sub">
        <button class="search__table-sort-btn" :class="[
          searchStore.warehousesListSorting.sortByDeliveryDate !== null && 'active',
          searchStore.warehousesListSorting.sortByDeliveryDate && 'rotate_arrow'
        ]" @click="searchStore.setWarehousesSorting('sortByDeliveryDate')">
          <span>Срок поставки</span>
          <span class="svg-fill-black">
            <SortIcon class="unfilled" />
          </span>
        </button>
      </div>
      <div class="search__table-cell-sub">
        Наличие
      </div>
      <div class="search__table-cell-sub">
        <button class="search__table-sort-btn" :class="[
          searchStore.warehousesListSorting.sortByPrice !== null && 'active',
          searchStore.warehousesListSorting.sortByPrice && 'rotate_arrow'
        ]" @click="searchStore.setWarehousesSorting('sortByPrice')">
          <span>Цена</span>
          <span class="svg-fill-black">
            <SortIcon class="unfilled" />
          </span>
        </button>
      </div>
      <div class="search__table-cell-sub">
        Кол-во
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.search__table {

  &-header,
  &-sort-btn {
    @include font(12px, 14px, 500);
    color: $content_secondary;
    display: flex;
  }

  &-header {
    @include md-breakpoint {
      display: none;
    }
  }

  &-sort-btn {
    align-items: center;
    background-color: transparent;

    svg {
      transform: rotateX(0);
    }

    &.active {
      color: $content_primary;

      svg {
        opacity: 1;
      }
    }

    &.rotate_arrow {
      svg {
        transform: rotateX(180deg);
      }
    }

    &:hover:not(:active, .active) {
      @include mf-breakpoint {
        svg {
          opacity: 1;
        }
      }
    }

    span {
      &:nth-child(2) {
        display: flex;
        align-items: center;
      }
    }

    svg {
      transition: .3s opacity;
      opacity: 0;
    }
  }
}
</style>
